module.exports = __webpack_public_path__ + "static/media/male.cc4fc62d.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/images/avatars/male.png
 ** module id = 12
 ** module chunks = 0
 **/